import React from 'react';
import classNames from 'classnames';
import classes from './Skeleton.module.scss';

interface IProps {
    className?: string;
    style?: React.CSSProperties;
}

export const Skeleton = React.memo<IProps>(
    (props) => (
        <div style={props.style} className={classNames(classes.skeleton, props.className)} />
    ),
    () => true,
);
